interface DataLayerEvent {
  event: string;
}

declare global {
  interface Window {
    dataLayer?: DataLayerEvent[];
  }
}

interface TagDelayService {
  triggered: boolean;
  timeoutId: ReturnType<typeof setTimeout> | null;
  init(): void;
}

const tagDelayService: TagDelayService = {
  triggered: false,
  timeoutId: null,

  init(): void {
    const DELAY_MS = 5000;
    const service = tagDelayService;

    if (!window.dataLayer) {
      window.dataLayer = [];
    }

    const handler = (): void => {
      if (service.triggered) return;
      service.triggered = true;

      if (service.timeoutId) {
        clearTimeout(service.timeoutId);
      }

      window.dataLayer!.push({ event: 'tag_delay_triggered' });
      document.removeEventListener('scroll', handler);
      document.removeEventListener('click', handler);
    };

    document.addEventListener('scroll', handler);
    document.addEventListener('click', handler);

    service.timeoutId = setTimeout(() => {
      handler();
    }, DELAY_MS);
  }
};

export { tagDelayService };
